export default __webpack_public_path__ + "static/media/logo_offical.8e5f724d.png";